import React from 'react';
import { Grid, Typography } from '@mui/material';
import { NumberField, SelectField } from 'react-admin';

import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';
import { timePeriodChoices } from '../../../constants/timePeriods';
import labels from '../../../constants/labels';
import { ThresholdField } from '../ruleParamsShortSummaries/AmountThreshold';

const CategorizationThreshold = () => (
  <Grid size={12}>
    <Grid container spacing={3}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Transaction monitoring mode
        </Typography>
        <SelectField
          source="ruleParameters.transactionMonitoringMode"
          choices={transactionMonitoringModesChoices}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Default threshold
        </Typography>
        <ThresholdField source="ruleParameters.default" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Period
        </Typography>
        <Typography>
          <NumberField source="ruleParameters.period.amount" />
          {' '}
          <SelectField source="ruleParameters.period.unit" choices={timePeriodChoices} />
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography fontWeight="bold">
          Category
        </Typography>
        <SelectField source="ruleParameters.category" choices={labels} />
      </Grid>
    </Grid>
  </Grid>
);

export default CategorizationThreshold;
